import { inputBaseClasses } from '@mui/material';

export const wbInputClasses = {
  ...inputBaseClasses,
};
